module.exports = __webpack_public_path__ + "img/new4-img2.049bec0b.png";